import { Component } from '@angular/core';
import { DashboardService } from '../../../../core/services/dashboard/dashboard.service';
import { LanguageService } from '../../../../core/services/language.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboar-main',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './dashboar-main.component.html',
  styleUrl: './dashboar-main.component.scss',
})
export class DashboarMainComponent {
  totalPatientCount: number = 0;
  totalImageCount: number = 0;
  totalECGCount: number = 0;
  totalConsultationCount: number = 0;

  constructor(
    private dashboardService: DashboardService,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    const userLang = this.languageService.getLanguage() || 'en';
    this.translate.use(userLang);
  }

  ngOnInit(): void {
    this.getDashboardInformations();
  }

  getDashboardInformations(): void {
    this.dashboardService.dashboardCountInformations().subscribe({
      next: (res) => {
        this.totalPatientCount = res.totalPatientCount;
        this.totalImageCount = res.totalImageCount;
        this.totalConsultationCount = res.totalConsultationCount;
      },
      error: () => {},
    });
  }
}
